import { useMemo, useCallback } from 'react';
import styles from './GanttTodayLine.module.scss';

export function useGanttTodayLine({ scale }) {
  const now = new Date();

  const getPeriodStart = (date) => {
    const value = new Date(date);

    if (scale === 'day') {
      value.setHours(0, 0, 0, 0);
      return value;
    }

    if (scale === 'week') {
      value.setHours(0, 0, 0, 0);
      const day = value.getDay();
      value.setDate(value.getDate() - day);
      return value;
    }

    return new Date(value.getFullYear(), value.getMonth(), 1);
  };

  const getPeriodEnd = (date) => {
    const start = getPeriodStart(date);

    if (scale === 'day') {
      const end = new Date(start);
      end.setDate(end.getDate() + 1);
      return end;
    }

    if (scale === 'week') {
      const end = new Date(start);
      end.setDate(end.getDate() + 7);
      return end;
    }

    return new Date(start.getFullYear(), start.getMonth() + 1, 1);
  };

  const todayOffset = useMemo(() => {
    const start = getPeriodStart(now);
    const end = getPeriodEnd(now);
    const ratio = (now - start) / (end - start);
    return `${Math.max(0, Math.min(1, ratio)) * 100}%`;
  }, [scale]);

  const highlightTime = useCallback((date, columnScale) => {
    if (scale !== columnScale) return '';
    const current = getPeriodStart(now).getTime();
    const target = getPeriodStart(date).getTime();
    return current === target ? styles['today-col'] : '';
  }, [scale]);

  return { todayOffset, highlightTime };
}
